<template>
    <div :class="$style.root">
        <bannerView />
        <!--<announcementView v-if="userInfo.role_id" />-->
        <newVideoViewdemo v-if="userInfo.role_id" />
        <newHotView v-if="userInfo.role_id" />
    </div>
</template>

<script>
    import { mapState,mapActions } from 'vuex';
    import bannerView from './components/bannerView.vue';
    import announcementView from './components/announcementView.vue';
    import newVideoViewdemo from './components/newVideoViewdemo.vue';
    import newHotView from './components/newHotView.vue';
    import auth from '../../utils/auth';

    export default {
        name: 'IndexVideoView',

        components: { bannerView, announcementView, newVideoViewdemo, newHotView },

        data() {
            return {};
        },
        created(){

            let   params =this.$route.query
            
            if(params.token){
                
                    this.login(params)
            }
            
        },
        computed: {
            ...mapState(['userInfo']),

        },
        mounted() {


        },

        methods: {
                 ...mapActions(['ssorequestPasswordLogin', 'gerUserInfo']),
                 
                login(values){
                    this.ssorequestPasswordLogin(values)
                        .then((res) => {
                            console.log(res)
                            
                            if (res.data) {
                                // this.onReset();

                                // this.$message.success('登录成功');
                                // this.isVisible = false;
                                // this.$router.go(0);
                            } else {
                                // this.$message.error('登录失败,用户名或密码错误');
                            }
                        })
                        .catch(({ message }) => {
                            // this.onRefreshCode();
                            this.isVisible = false;
                            // if (message) this.$message.error('登录失败,用户名或密码错误');
                        });
                }
        },
    };
</script>
<style lang="less" module>
    .root {
        :global {
            .box-news {
                display: flex;
                justify-content: space-between;

                .box-news-video {

                }
            }
        }
    }
</style>
